import React from "react";
import Hero from "../Components/Hero/Hero";
import About from "../Components/About/About";
import SentosaSection from "../Components/SentosaSection/SentosaSection";
import Highlights from "../Components/Highlights/Highlights";
import Pricing from "../Components/Pricing/Pricing";
import FloorPlan from "../Components/FloorPlan/FloorPlan";
import Amenities from "../Components/Amenities/Amenities";
import Specifications from "../Components/Specifications/Specifications";
import Connectivity from "../Components/Connectivity/Connectivity";
import Contact from "../Components/Contact/Contact";


export default function Home() {
  return (
    <div>
      <Hero />
      <About />
     <SentosaSection />
      <Highlights />
      <Pricing />
      <FloorPlan />
      <Amenities />
      <Specifications />
      <Connectivity />
      <Contact />
      {/* Hero Section */}



    
      {/* Yaha aap future me aur sections (jaise Services, Contact) add kar sakte hain */}
      {/* <Services /> */}
      {/* <Contact /> */}
    </div>
  );
}